(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pivot-header-item"] && !Shopify.designMode) return;
  try {
    let globalMMTimeout = 0;

  class PvtMegamenuItem extends HTMLElement {
    constructor() {
      super();
      this.$detail = this.querySelector('details');
      this.$trigger = this.$detail.querySelector('summary');
      this.$dropdown = this.$detail.querySelector('.pivot-megamenu-item__dropdown');
      this.$aside = this.querySelector('.pivot-megamenu-item__main-aside ul');
      this.$subItemsWrapper = this.querySelector('.pivot-megamenu-item__subitems');
      this.$parent = this.closest('.shopify-section');
      this.openMode = this.dataset.openMode;
      this.sidemenuBehavior = this.dataset.sidemenuBehavior;
      this.isTouch = window.matchMedia('(hover:none)');
      this.hideDebounce = 0;

      // Cerrar el menu al esconder el header
      const observer = new MutationObserver((entries) => {
        entries.forEach((entry) => {
          if (!this.$detail.open) return;
          const clss = this.$parent.getAttribute('class');
          if (clss === entry.oldValue) return;
          this.$detail.open = !this.$parent.classList.contains('shopify-section-header-hidden');
        });
      });
      observer.observe(this.$parent, {
        attributeFilter: ['class'],
        attributes: true,
        attributeOldValue: true,
      });

      // Cerrar al clickear fuera
      this.$dropdown.addEventListener(
        'mouseleave',
        (e) => {
          if (e.target === this.$dropdown) {
            this.$detail.open = false;
          }
        },
        false
      );

      // Hover en los elementos internos
      const openMenu = (e) => {
        e.preventDefault();
        clearTimeout(globalMMTimeout);
        globalMMTimeout = setTimeout(() => {
          const $newMenuActive = this.$aside.querySelector('.pivot-megamenu-item__main-aside-link:hover');
          if (!$newMenuActive) return;

          const $currentMenuActive = this.$aside.querySelector('.active');
          const $currentGridActive = this.$subItemsWrapper.querySelector('.active');

          if ($currentMenuActive) $currentMenuActive.classList.remove('active');
          if ($currentGridActive) $currentGridActive.classList.remove('active');

          $newMenuActive.classList.add('active');
          this.$subItemsWrapper.querySelector(`#${$newMenuActive.dataset.item}`)?.classList.add('active');
        }, 70);
      };
      this.$aside.addEventListener(
        this.sidemenuBehavior === 'navigate' && !this.isTouch.matches ? 'mouseover' : 'click',
        openMenu
      );

      this.$subItemsWrapper.addEventListener('mouseover', () => clearTimeout(globalMMTimeout));
      // Hover en el trigger
      if (this.openMode === 'hover')
        this.$trigger.addEventListener('mouseover', () => {
          this.$detail.open = true;
        });

      // Ocultar al salir del trigger
      this.$trigger.addEventListener('mouseleave', (e) => {
        this.hideDebounce = setTimeout(() => {
          this.$detail.open = false;
        }, 250);
      });
      this.$dropdown.addEventListener('mouseover', () => {
        if (this.hideDebounce) clearTimeout(this.hideDebounce);
      });
    }
  }
  if (!customElements.get('pvt-megamenu-item')) {
    customElements.define('pvt-megamenu-item', PvtMegamenuItem);

    // Abrir/cerrar otros elementos del megamenú
    const stickyHeader = document.querySelector('sticky-header');
    console.log('Cierre atomático details', stickyHeader);
    const summaries = document.querySelectorAll(
      'sticky-header .list-menu--inline > li > header-menu > details, sticky-header .list-menu--inline > li > pvt-megamenu-item > details'
    );

    const openObserver = new MutationObserver((entries) =>
      entries.forEach((entry) => {
        console.log('entry', entry);
        const parentName = entry.target.parentElement.tagName.toLowerCase();
        console.log('ParentName', parentName);
        if (!entry.target.open || (parentName != 'header-menu' && parentName != 'pvt-megamenu-item')) return;
        // console.log('Abrimos', entry.target)
        summaries.forEach((el) => {
          console.log('Elemento', el);
          if (el !== entry.target) el.open = false;
        });
      })
    );

    // Subscribir todos los summaries
    openObserver.observe(stickyHeader, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true,
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mky-pestanas-movil"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mky-pestanas-movil')) {
    class MkyPestanasMovil extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        const wrapper = this.closest('.pd-split-wrapper');
        if (!wrapper) return;
        this._init = true;
        this.wrapper = wrapper;
        // Se saca del contenedor para no alterar los :first-child / :last-child
        // que usa la sección en escritorio.
        wrapper.after(this);

        this.mq = window.matchMedia('(max-width: 767px)');
        this._onMq = () => this.sync();
        this._onHash = () => this.irAHash();
        this._onSelect = (e) => this.alSeleccionarBloque(e);
        this.mq.addEventListener('change', this._onMq);
        window.addEventListener('hashchange', this._onHash);
        document.addEventListener('shopify:block:select', this._onSelect);

        this.sync();
        if (location.hash) this.irAHash();
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return; // solo fue movido
          this.mq?.removeEventListener('change', this._onMq);
          window.removeEventListener('hashchange', this._onHash);
          document.removeEventListener('shopify:block:select', this._onSelect);
          this.desactivar();
        });
      }

      sync() {
        this.mq.matches ? this.activar() : this.desactivar();
      }

      detectar() {
        const orden = { desc: 0, spec: 1, faq: 2 };
        const usados = new Set();
        const lista = [];
        [...this.wrapper.children].forEach((el) => {
          if (el.classList.contains('mky-pm-bar')) return;
          const det = el.matches('details.pd-accordion') ? el : el.querySelector('details.pd-accordion');
          const cuerpo = el.querySelector('.pd-content-toggle') || el;
          let tipo = 'faq';
          if (el.querySelector('.pd-specs-table')) tipo = 'spec';
          else if (el.querySelector('.pd-description-content')) tipo = 'desc';

          const vacio = tipo === 'spec'
            ? !el.querySelector('.pd-specs-table tr')
            : !cuerpo.textContent.trim();
          if (vacio) return;

          const titulo = det?.querySelector(':scope > summary')?.textContent.trim() || '';
          let label = this.dataset['l' + tipo.charAt(0).toUpperCase() + tipo.slice(1)] || titulo;
          if (usados.has(tipo)) label = titulo || label;
          usados.add(tipo);

          let cant = 0;
          if (tipo === 'faq') cant = [...el.querySelectorAll('details')].filter((d) => d !== det).length;

          lista.push({ el, det, tipo, label, cant, pos: orden[tipo] ?? 3 });
        });
        return lista.sort((a, b) => a.pos - b.pos);
      }

      activar() {
        if (this.bar) return;
        const lista = this.detectar();
        if (lista.length < 2) return; // con un solo contenedor no tiene sentido
        this.lista = lista;

        const bar = document.createElement('div');
        bar.className = 'mky-pm-bar';
        bar.setAttribute('role', 'tablist');
        bar.dataset.sticky = this.dataset.sticky;
        if (this.dataset.acento) bar.style.setProperty('--mky-pm-acento', this.dataset.acento);
        bar.style.setProperty('--mky-pm-top', (this.dataset.top || 0) + 'px');
        if (this.dataset.fs) bar.style.setProperty('--mky-pm-fs', this.dataset.fs + 'px');

        const base = 'mky-pm-' + Math.random().toString(36).slice(2, 7);
        lista.forEach((p, i) => {
          if (!p.el.id) { p.el.id = `${base}-p${i}`; p.idPuesto = true; }
          p.el.classList.add('mky-pm-panel');
          p.el.setAttribute('role', 'tabpanel');
          p.el.setAttribute('aria-labelledby', `${base}-t${i}`);
          if (p.det) {
            p.abiertoOrig = p.det.open;
            p.det.open = true;
            p.det.classList.add('mky-pm-abierto');
          }

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.id = `${base}-t${i}`;
          btn.className = 'mky-pm-tab';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-controls', p.el.id);
          btn.textContent = p.label;
          if (p.cant && this.dataset.contador === 'true') {
            const s = document.createElement('span');
            s.className = 'mky-pm-cant';
            s.textContent = ` (${p.cant})`;
            btn.append(s);
          }
          btn.addEventListener('click', () => this.seleccionar(i, true));
          btn.addEventListener('keydown', (e) => {
            const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
            if (!d) return;
            e.preventDefault();
            const j = (i + d + lista.length) % lista.length;
            this.seleccionar(j, false);
            lista[j].btn.focus();
          });
          p.btn = btn;
          bar.append(btn);
        });

        this.bar = bar;
        this.wrapper.prepend(bar);
        this.wrapper.classList.add('mky-pm-on');

        const ini = lista.findIndex((p) => p.tipo === this.dataset.inicial);
        this.seleccionar(ini >= 0 ? ini : 0, false);
      }

      desactivar() {
        if (!this.bar) return;
        this.lista.forEach((p) => {
          p.el.classList.remove('mky-pm-panel', 'mky-pm-oculto');
          p.el.removeAttribute('role');
          p.el.removeAttribute('aria-labelledby');
          if (p.idPuesto) p.el.removeAttribute('id');
          if (p.det) {
            p.det.open = p.abiertoOrig;
            p.det.classList.remove('mky-pm-abierto');
          }
        });
        this.bar.remove();
        this.bar = null;
        this.lista = null;
        this.wrapper.classList.remove('mky-pm-on');
      }

      seleccionar(i, desplazar) {
        this.lista.forEach((p, j) => {
          const on = j === i;
          p.btn.setAttribute('aria-selected', on);
          p.btn.tabIndex = on ? 0 : -1;
          p.el.classList.toggle('mky-pm-oculto', !on);
        });
        if (desplazar) {
          // Si la barra quedó fija, se vuelve al inicio del contenido
          const top = parseFloat(this.dataset.top || 0);
          const r = this.wrapper.getBoundingClientRect();
          if (r.top < top) {
            window.scrollTo({ top: window.scrollY + r.top - top, behavior: 'smooth' });
          }
        }
      }

      irAHash() {
        const mapa = { '#descripcion': 'desc', '#especificaciones': 'spec', '#preguntas': 'faq' };
        const tipo = mapa[location.hash.toLowerCase()];
        if (!tipo) return;
        if (this.bar) {
          const i = this.lista.findIndex((p) => p.tipo === tipo);
          if (i < 0) return;
          this.seleccionar(i, false);
          this.bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          const p = this.detectar().find((p) => p.tipo === tipo);
          p?.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      alSeleccionarBloque(e) {
        if (!this.lista) return;
        const i = this.lista.findIndex((p) => p.el.contains(e.target));
        if (i >= 0) this.seleccionar(i, false);
      }
    }
    customElements.define('mky-pestanas-movil', MkyPestanasMovil);
  }
  } catch(e) { console.error(e); }
})();

})();
